module.exports = __webpack_public_path__ + "img/bb_fire.14aae3e8.gif";